import { isAxiosError } from "axios";

export function extractApiErrorMessage(err: unknown, fallback: string): string {
  if (isAxiosError(err)) {
    const data = err.response?.data;
    if (data && typeof data === "object") {
      const detail = (data as { detail?: unknown }).detail;
      if (typeof detail === "string" && detail.trim()) return detail;
      if (detail && typeof detail === "object") {
        const message = (detail as { message?: unknown }).message;
        if (typeof message === "string" && message.trim()) return message;
      }
    }
    if (err.message && err.message !== "Network Error") return err.message;
  } else if (err instanceof Error && err.message) {
    return err.message;
  }
  return fallback;
}

export function extractApiErrorCode(err: unknown): string | null {
  if (isAxiosError(err)) {
    const data = err.response?.data;
    if (data && typeof data === "object") {
      const code = (data as { error_code?: unknown }).error_code;
      if (typeof code === "string" && code.trim()) return code;
    }
  }
  return null;
}
